import {
  RegExpMatcher,
  DataSet,
  englishDataset,
  englishRecommendedTransformers,
  pattern,
} from 'obscenity';

const allowlist = [
  'hells',
  'hell',
  'sadist',
  'tit',
  'tits',
  'queef',
  'dominatricks',
  'dominatrics',
  'dominatrix',
];

const blocklist = ['trump'];

const customDataset = new DataSet<{ originalWord: string }>()
  .addAll(englishDataset)
  .removePhrasesIf((phrase) =>
    phrase.metadata ? allowlist.includes(phrase.metadata.originalWord) : false
  );

for (const word of blocklist) {
  customDataset.addPhrase((phrase) =>
    phrase.setMetadata({ originalWord: word }).addPattern(pattern`${word}`)
  );
}

const matcher = new RegExpMatcher({
  ...customDataset.build(),
  ...englishRecommendedTransformers,
});

export let detectToxicHandle = (handle?: string) => {
  if (!handle) return undefined;

  return matcher.hasMatch(handle);
};
